import request from '@/utils/request'

//Login
export function getNonGATree1(params) {
  return request({ url: 'getnongatree', method: 'post', data: params })
} 
